import classNames from "classnames";
import React from "react";
import { IconSizes } from "../../Icons/PropTypes/IconSizes";
import { CancelIcon } from "../../Icons";
/** To use custom content, do not pass `title` or `subtitle`, and just pass `children` */
const ModalHeader = ({ title, subtitle, className, onCancel, children, hideCancelIcon, loading, }) => {
    if (!title && !subtitle && !children)
        return null;
    const hideHeaderText = !title && !subtitle;
    const hideDefaultHeader = hideCancelIcon && hideHeaderText;
    const onCancelClick = (e) => {
        if (!loading && onCancel)
            onCancel(e);
    };
    return (React.createElement("header", { className: classNames("gerudo-modal-header", className) },
        !hideDefaultHeader && (React.createElement("div", { className: "gerudo-modal-header-basic" },
            !hideHeaderText && (React.createElement("div", null,
                React.createElement("h1", null, title),
                React.createElement("h2", null, subtitle))),
            !hideCancelIcon && (React.createElement(CancelIcon, { "data-testid": "modal-close-btn", size: IconSizes.Small, onClick: onCancelClick })))),
        children));
};
export default ModalHeader;
export { ModalHeader };
//# sourceMappingURL=ModalHeader.js.map